import { state } from "@src/state";
export function setMixerOpen(isOpen) {
    state.meeting.studio.mixer.setPanelOpen(isOpen);
}
